module.exports = __webpack_public_path__ + "static/media/add-collaborator-screenshot.a4c83c52.png";